import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { adminEndpoints } from "@/features/admin/api/endpoints";
import type {
  ApprovalRequestDto,
  ApprovalRequestFilter,
} from "@/features/admin/api/dto";

/**
 * File d'attente paginée des demandes d'approbation
 * (`POST /ApprovalRequests/all` — les listes sont en POST, guide §4.2).
 * Rôles : flashpay-superadmin, flashpay-admin, flashpay-service (§6.8).
 */
export const useApprovalRequests = (
  params: ListRequest<ApprovalRequestFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.ADMIN_APPROVAL_REQUESTS_LIST(params),
    queryFn: () =>
      mutateData({
        url: adminEndpoints.approvalRequests.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<ApprovalRequestDto>>,
    enabled,
  });
